<template>
  <div>
    <h3>选择需求</h3>
    <el-tree
      ref="demandTree"
      :data="treeData"
      show-checkbox
      node-key="key"
      default-expand-all
      :default-checked-keys="defaultList"
      :props="defaultProps"
      @check="getChecked"
      >
      <span class="custom-tree-node1" slot-scope="{ node, data }">
        <el-tag size="mini" v-if="data[hasChechedWord]">已设置</el-tag>
        <span>{{ data.label }}</span>
      </span>
    </el-tree>
  </div>
</template>

<script>
import * as api from './api'
export default {
  props:{
    projectVersionId:String,
    defaultList:{
      type:Array,
      default:function(){
        return []
      }
    },
    treeDatas:{
      type:Array
    },
    hasChechedWord:{
      type:String,
      default:''
    }
  },
  data(){
    return {
      treeData:[],
      defaultProps: {
        children: 'children',
        label: 'label'
      }
    }
  },
  watch:{
    treeDatas(){
      this.treeData = this.treeDatas
    }
  },
  methods:{
    getTreeData(){
      if(this.projectVersionId){
        api.getDemandList(this.projectVersionId).then(res=>{
          this.treeData = res
        })
      } else{
        this.treeData = this.treeDatas
      }
      
    },
    getChecked(checkedNodes,checkedKeys){
      this.$emit('getChecked',{checkedNodes,checkedKeys})
      // console.log(checkedNodes,checkedKeys)
    },
    resetTree(){
      this.$refs.demandTree.setCheckedKeys([]);
    }
  },
  mounted(){
    this.getTreeData()
  }
}
</script>


// WEBPACK FOOTER //
// src/components/demandTree/index.vue